//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { AddUpdateSettings } from './models/AddUpdateSettings';
import type { Settings } from './models/Settings';
import { Utilities } from './Utilities';

export class SettingsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
			icIds?: string,
        ): string => {
            let clientRequestUrl = '/api/v1/settings?';
            if (icIds === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('icIds'));
            } else if (icIds !== undefined) {
                clientRequestUrl += `icIds=${encodeURIComponent(String(icIds))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        add: (): string => {
            let clientRequestUrl = '/api/v1/settings';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        update: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/settings/{id}';
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/settings/{id}';
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves settings by parameters
     * @param icIds (optional) Get a list of settings by the id of the contact.
    Comma separated list of guid.
     * @return OK
     */
    async get(
        icIds?: string,
    ): Promise<Settings[]> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
            icIds,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<Settings[]>(_response, false, []);
    }

    /**
     * Add a new settings.
     * @param body (optional) The settings to be added
     * @return Created
     */
    async add(
        body?: AddUpdateSettings,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.add();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Update the entire settings by id
     * @param id The id of the settings
     * @param body (optional) The settings to update
     * @return No Content
     */
    async update(
        id: number,
        body?: AddUpdateSettings,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.update(
            id,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Retrieves settings by id
     * @param id The settings id
     */
    async getById(
        id: number,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.getById(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }
}
